export enum EnumTipoDeCupom{
 Percentual = 'percentual',
 Valor = 'valor',
 FreteGratis = 'frete gratis',

}
